import { render, staticRenderFns } from "./ToastController.vue?vue&type=template&id=52a78e53"
import script from "./ToastController.vue?vue&type=script&lang=js"
export * from "./ToastController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports